export default __webpack_public_path__ + "static/media/complementary--chevron-left--g5.2f7987c9.png";